'use strict';

angular.module('commerce').controller('SubscriptionDetailsController', [
    'CommerceSubscription',
    function(CommerceSubscription) {
        var vm = this;

        vm.license = null;
        vm.ready = false;

        function reloadLicense() {
            return CommerceSubscription.getCurrentLicense(vm.study.get('subdomain'))
                .then(function(license) {
                    vm.license = license;
                });
        }

        vm.$onInit = function() {
            return reloadLicense()
                .finally(function() {
                    vm.ready = true;
                });
        };
    },
]);
